import { useContentSingletons, usePageContent } from "@robe/client/xcore-ui";
import { Box, Collapse, Link, Typography } from "@xcorejs/ui";
import Richtext from "design-system/Richtext";
import { useState } from "react";
import { useLayout } from "xcore";
import { ProductOverviewPage, Products } from "xcore/types";

const OverviewText = () => {
  const { values } = usePageContent<ProductOverviewPage>();
  const [products] = useContentSingletons<[Products]>();
  const { general, stringify, localize, richtextToString } = useLayout();
  const [showDescription, setShowDescription] = useState(false);

  const descriptionResolved = localize(values?.description);
  const description = descriptionResolved ? (richtextToString(descriptionResolved) === "" ? null : descriptionResolved) : null;

  const introResolved = localize(values?.intro ?? products?.values.intro);
  const intro = introResolved ? (richtextToString(introResolved) === "" ? null : introResolved) : null;

  if (!intro && !description) {
    return null;
  }

  return (
    <Box mt={{ _: "3rem", sm: "6rem" }}>
      <Typography variant="lead" maxWidth="85rem" margin="0 auto" textAlign="center" as="div">
        {intro && <Richtext value={intro} _paragraph={{ variant: "lead" }} />}

        {!showDescription && description && (
          <Link
            as="span"
            onClick={() => setShowDescription(!showDescription)}
            fontSize="inherit"
            borderBottom="1px solid #e00034"
            _hover={{ borderBottom: "1px solid transparent" }}
            lineHeight="2.6rem"
          >
            {" "}
            {stringify(general.values.readMore)}...
          </Link>
        )}
      </Typography>

      {description && (
        <Collapse open={showDescription}>
          <Typography variant="lead" maxWidth="85rem" margin="0 auto" textAlign="center" as="div">
            <Richtext value={description} _paragraph={{ variant: "lead" }} />
            {showDescription && (
              <Link
                as="span"
                onClick={() => setShowDescription(!showDescription)}
                fontSize="inherit"
                borderBottom="1px solid #e00034"
                _hover={{ borderBottom: "1px solid transparent" }}
              >
                {stringify(general.values.readLess)}
              </Link>
            )}
          </Typography>
        </Collapse>
      )}
    </Box>
  );
};

export default OverviewText;
